angular.module("vgresiduos").controller("EquipmentAllocationListCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `alocacao-equipamentos`);
		};
	}
]);
